/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Filter,
  HTTPValidationError,
  TradeHistoryPage,
} from '../models/index';
import {
    FilterFromJSON,
    FilterToJSON,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    TradeHistoryPageFromJSON,
    TradeHistoryPageToJSON,
} from '../models/index';

export interface GetTradeHistoryRequest {
    pageIndex?: number;
    pageSize?: number;
    sortLabel?: string;
    sortDesc?: boolean;
    filter?: Array<Filter>;
}

/**
 * 
 */
export class TradeHistoryApi extends runtime.BaseAPI {

    /**
     * Retrieve trade history items with the specified filters.
     */
    async getTradeHistoryRaw(requestParameters: GetTradeHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TradeHistoryPage>> {
        const queryParameters: any = {};

        if (requestParameters.pageIndex !== undefined) {
            queryParameters['page_index'] = requestParameters.pageIndex;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }

        if (requestParameters.sortLabel !== undefined) {
            queryParameters['sort_label'] = requestParameters.sortLabel;
        }

        if (requestParameters.sortDesc !== undefined) {
            queryParameters['sort_desc'] = requestParameters.sortDesc;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/trade-history`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.filter?.map(FilterToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TradeHistoryPageFromJSON(jsonValue));
    }

    /**
     * Retrieve trade history items with the specified filters.
     */
    async getTradeHistory(requestParameters: GetTradeHistoryRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TradeHistoryPage> {
        const response = await this.getTradeHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Invalidate and update trade history cache
     */
    async invalidateTradeHistoryCacheRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/trade-history-cache`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Invalidate and update trade history cache
     */
    async invalidateTradeHistoryCache(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.invalidateTradeHistoryCacheRaw(initOverrides);
        return await response.value();
    }

}
